function SmoothScrollIntoView() {
    function scrollToLocation(target) {
        var element = document.getElementById(target);
        if (!element) return;

        // Smooth scrolling using native JavaScript
        element.scrollIntoView({ behavior: "smooth", block: "start", inline: "start" });

        element.focus();
    }

    // Get all links on a page that include a hash symbol, excluding specific ones.
    var anchorsLinks = document.querySelectorAll(
        'a[href^="#"]:not([href="#"]):not([href="#onetrust"])'
    );

    if (anchorsLinks.length) {
        Array.prototype.forEach.call(anchorsLinks, function (anchor) {
            anchor.addEventListener("click", function (e) {
                e.preventDefault();
                var target = anchor.getAttribute("href").substring(1);
                scrollToLocation(target);
            });

            anchor.addEventListener("keydown", function (e) {
                if (e.key === " " || e.key === "Enter") {
                    e.preventDefault();
                    var target = anchor.getAttribute("href").substring(1);
                    scrollToLocation(target);
                }
            });
        });
    }
}

SmoothScrollIntoView();
